<template>
  <v-card>
    <v-card-title>
      Measurement Threshold
      (List the {{ items.length }} available thresholds. Latest record at the top)
      <v-btn small icon @click="dataRefresh">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search">
      </v-text-field>
    </v-card-title>
    <v-progress-linear
      :indeterminate="true"
      :active="showProgress">
    </v-progress-linear>
    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:rows-per-page-items="rowsPerPage"
      :disable-initial-sort="true">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ showMeasurementType(props.item.measurementType) }}</td>
        <td class="text-xs-left">{{ props.item.baselineLow }}
          <v-dialog v-model="dialogLow" max-width="500px" hide-overlay lazy>
            <v-btn small icon slot="activator" @click.native="updateId = props.item.recordId, updateLow = props.item.baselineLow, updateHigh = null"><v-icon color="grey">edit</v-icon></v-btn>
            <v-form v-model="valid">
              <v-card>
                <v-card-text>
                  <v-text-field
                    v-model="updateLow"
                    label="Baseline Low"
                    type="text"
                    hint="Please enter baseline low here"
                    :rules="baselineRules"
                    required
                    clearable
                  ></v-text-field>
                </v-card-text>
                <small>*indicates required field</small>
                <v-spacer></v-spacer>
                <v-btn flat color="blue darken-1"
                  @click.native="dialogLow = false">Close</v-btn>
                <v-btn flat color="blue darken-1"
                  @click.native="update" :disabled="!valid">Save</v-btn>
              </v-card>
            </v-form>
          </v-dialog>
        </td>
        <td class="text-xs-left">{{ props.item.baselineHigh }}
          <v-dialog v-model="dialogHigh" max-width="500px" hide-overlay lazy>
            <v-btn small icon slot="activator" @click.native="updateId = props.item.recordId, updateLow = null, updateHigh = props.item.baselineHigh"><v-icon color="grey">edit</v-icon></v-btn>
            <v-form v-model="valid">
              <v-card>
                <v-card-text>
                  <v-text-field
                    v-model="updateHigh"
                    label="Baseline High"
                    type="text"
                    hint="Please enter baseline high here"
                    :rules="baselineRules"
                    required
                    clearable
                  ></v-text-field>
                </v-card-text>
                <small>*indicates required field</small>
                <v-spacer></v-spacer>
                <v-btn flat color="blue darken-1"
                  @click.native="dialogHigh = false">Close</v-btn>
                <v-btn flat color="blue darken-1"
                  @click.native="update" :disabled="!valid">Save</v-btn>
              </v-card>
            </v-form>
          </v-dialog>
        </td>
        <td class="text-xs-left">{{ localAt(props.item.lastUpdatedAt) }}</td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ errMsg }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import UserThresholdService from '@/services/UserThresholdService'
  import moment from 'moment'

  export default {
    data() {
      return {
        errMsg: '',
        valid: false,
        updateId: 0,
        updateLow: 0,
        updateHigh: 0,
        dialogLow: false,
        dialogHigh: false,
        showProgress: true,
        baselineRules: [
          (v) => !!v || 'baseline is required',
          (v) => /(^\d+$)|(^\+?\d+$)/.test(v) || 'baseline must be digits'
        ],
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        rowsPerPage: [
          10,
          20,
          {"text": "All", "value": -1}
        ],
        headers: [
          { text: 'Measurement Type', align: 'left', value: 'measurementType.description' },
          { text: 'Baseline Low', align: 'left', value: 'baselineLow' },
          { text: 'Baseline High', align: 'left', value: 'baselineHigh' },
          { text: 'Last Updated At', align: 'left', value: 'lastUpdatedAt' },
        ],
        items: []
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.errMsg = ''
        this.items = []
        this.showProgress = true
        const careUserId = this.$route.params.id
        this.items = (await UserThresholdService.showThresholdPerCareUser({careUserId})).data
        console.log('careuser threshold,careUserId[' + careUserId + '], this.items[' + this.items + ']')
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.errMsg = this.handleError(error)
      }
    },
    methods: {
      async update() {
        try {
          this.errMsg = ''
          this.dialogLow = false
          this.dialogHigh = false
          const response = await UserThresholdService.updateLowOrHigh({
            recordId: this.updateId,
            baselineLow: this.updateLow,
            baselineHigh: this.updateHigh
          })
          this.showProgress = true
          const careUserId = this.$route.params.id
          this.items = (await UserThresholdService.showThresholdPerCareUser({careUserId})).data
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      },
      async dataRefresh() {
        try {
          this.errMsg = ''
          this.showProgress = true
          this.items = []
          this.showProgress = true
          const careUserId = this.$route.params.id
          this.items = (await UserThresholdService.showThresholdPerCareUser({careUserId})).data
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      },
      localAt: function(time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss.SSS A")
      },
      showMeasurementType: function(measurementType) {
        if (measurementType) {
            return measurementType.description
        } else {
          return null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CareUser/CareUserThreshold.vue